import Accordion from 'accordion-js';

function privacyAccordion() {
    if ( !document.querySelector('.section-accordion') ) {
        return;
    }
    new Accordion('.accordion-container');
}

export default function () {
    privacyAccordion()
}